export default {
  automations: { automations: [] },
  automationsReport: {}
};
